import { cx } from "@emotion/css";
import dayjs from "dayjs";

import { useTranslation } from "react-i18next";
import { generatePath, useHistory } from "react-router-dom";
import { toast } from "react-toastify";
import routing from "routing";
import { useCreateCourse } from "src/hooks/useCourses";
import useSearchParams from "src/hooks/useSearchParams";
import CourseIcon from "src/images/Icons/newIcons/navigation/courses.svg";
import { ExamTypes } from "src/types/enums";

import { Header } from "../../Main/ExamsBox/ExamsBox";
import DateFilter from "../Filters/CourseFilters/DateFilter";
import DefaultExamCreator from "./DefaultExamCreator";

export const initialState = {
	questionsPerDay: 20,
	endDate: dayjs(new Date(), "DD/MM/YYYY"),
	typeDetails: {
		type: ExamTypes.COURSE,
	},
};

export default function NewCourseCreator() {
	const { t } = useTranslation();
	const history = useHistory();
	const search = useSearchParams();
	const { mutateAsync } = useCreateCourse();
	const initialSelectedFolderIds = search?.folderId ? [search.folderId] : [];

	const onSubmit = async (details, name, _count, folderIds) => {
		try {
			const { id } = await mutateAsync({
				name,
				filters: details,
				folderIds,
			});

			const path = generatePath(routing.paths.course, { id });
			return history.push(path);
		} catch (err) {
			if (err.response && err.response.status === 422) {
				toast.error(t("errors.tooManyLessons"), {
					position: toast.POSITION.BOTTOM_LEFT,
					pauseOnHover: false,
					autoClose: 5000,
				});
			}
		}
	};

	const renderExtraFilters = (details, setDetails, { count }) => {
		return (
			<DateFilter
				courseDetails={details}
				setDetails={setDetails}
				queryLength={count}
			/>
		);
	};

	return (
		<DefaultExamCreator
			inputPlaceholder={t("creators.courses.inputPlaceholder")}
			Header={
				<Header
					className="flex-1"
					title={t("table.courses.title")}
					icon={<CourseIcon className={cx("icon-super-big icon-logo")} />}
					withBackButton
				/>
			}
			onSubmit={onSubmit}
			renderExtraFilters={renderExtraFilters}
			extraInitialState={initialState}
			disabledShuffle
			initialSelectedFolderIds={initialSelectedFolderIds}
		/>
	);
}
